// features/workstations/dashboard-sections/pipeline-intelligence.js
// ═══════════════════════════════════════════════════════════
// Pipeline Intelligence (Long-Term 10x)
// ═══════════════════════════════════════════════════════════
// The 5-stage funnel: Scout → Monitor → Pilot → Conviction → Max.
// Each stage shows a count + the conviction score range driving it.
//
// V1: stages come from config.criteria.pipeline_stages; counts
// show "—" until Companies (Pipeline tab) persists entries.
// V2: live counts from the pipeline tab, plus "moved this week"
// deltas showing flow through the funnel.
// ═══════════════════════════════════════════════════════════

import ShiftRead from './shift-read';

// Visual color per stage — matches the mental model:
// scout=dim, monitor=static, pilot=gold, conviction=sage, max=sage-bright.
const STAGE_TONES = {
  scout:      'dim',
  monitor:    'static',
  pilot:      'gold',
  conviction: 'sage',
  max:        'sage-strong',
};

export default function PipelineIntelligenceSection({ workstation }) {
  const stages = workstation?.config?.criteria?.pipeline_stages || [];
  if (stages.length === 0) return null;

  return (
    <section className="ws-section ws-section-pipeline">
      <div className="ws-section-header">
        <div className="ws-section-label">Pipeline Intelligence</div>
        <div className="ws-section-tag">Companies</div>
      </div>
      <div className="ws-section-body">
        <div className="ws-pipeline-grid">
          {stages.map((s) => (
            <div key={s.id} className={`ws-pipeline-stage ws-pipeline-stage-${STAGE_TONES[s.id] || 'static'}`}>
              <div className="ws-pipeline-stage-label">{s.label}</div>
              <div className="ws-pipeline-stage-count">—</div>
              <div className="ws-pipeline-stage-range">
                {s.range[0]} – {s.range[1]}
              </div>
            </div>
          ))}
        </div>

        <ShiftRead>
          Flow matters more than totals. One Scout that moves to
          Conviction in a quarter is worth ten that stay put.
        </ShiftRead>
      </div>
    </section>
  );
}
